var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid",staticStyle:{"margin-bottom":"50px"}},[_c('service-toolbar',{attrs:{"hide-archive-alert":_vm.isQuote ? false : true}}),_c('purchase-orders',{attrs:{"is-service-po":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }